import { FindHealthQuoteParams } from '@apis/HealthQuoteApi';
import { getRoute } from '@utils/route';

export type HealthQuoteBuyNewPageParams = FindHealthQuoteParams;

export const HEALTH_QUOTE_BUY_ROUTE_URL = '/health-insurance-quote-buy/*';
export const HEALTH_QUOTE_BUY_NEW_PAGE_URL = '/health-insurance-quote-buy';
export const HEALTH_QUOTE_BUY_EDIT_PAGE_URL = '/health-insurance-quote-buy/:orderNumber/edit';
export const HEALTH_QUOTE_BUY_REVIEW_PAGE_URL = '/health-insurance-quote-buy/:orderNumber/review';
export const HEALTH_QUOTE_BUY_CUSTOM_PAGE_URL = '/health-insurance-quote-buy/:orderNumber/custom';

type RouteParams = {
  orderNumber: string;
}

export const routeHealthQuoteBuyNewPage = (searchParams: HealthQuoteBuyNewPageParams) => getRoute(HEALTH_QUOTE_BUY_NEW_PAGE_URL, { searchParams });
export const routeHealthQuoteBuyEditPage = (routeParams: RouteParams) => getRoute(HEALTH_QUOTE_BUY_EDIT_PAGE_URL, { routeParams });
export const routeHealthQuoteBuyReviewPage = (routeParams: RouteParams) => getRoute(HEALTH_QUOTE_BUY_REVIEW_PAGE_URL, { routeParams });
export const routeHealthQuoteBuyCustomPage = (routeParams: RouteParams) => getRoute(HEALTH_QUOTE_BUY_CUSTOM_PAGE_URL, { routeParams });
